/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography, FormGroup, Button } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import en from "../../nls/en.json";
import { OptionsWrapper } from "../Styles/AcademicSubjectsStyle";
import { theme } from "../Styles/BasicInfo";
import { getMentorPayout } from "../../store/mentorSlice";
import { putSurvey, getUserInfo } from "../../store/studentSlice";

function PaymentInfo() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loggedInUserId, userInfo, isSurveyCompleted } = useSelector(({ studentInfoSlice }) => studentInfoSlice);

    const gotoStripe = async () => {
        const redirect = (data) => {
            window.location.href = data?.url;
        }
        dispatch(getMentorPayout(redirect, true));
    }

    const mentorApproval = () => {
        dispatch(putSurvey(loggedInUserId));
    }

    const [thankYouScreen, setThankYouScreen] = useState(false);
    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const myParam = searchParams.get('mentorRegistered');
        if (myParam) {
            setThankYouScreen(true);
        }
    }, []);

    useEffect(()=>{
        if(isSurveyCompleted){
            dispatch(getUserInfo());
        }
    },[isSurveyCompleted]);

    const defaultStepTitle = () => {
        return (<>
            <Typography variant="h3"> {thankYouScreen === false ? en.ALMOST_DONE : en.THANK_YOU} </Typography>
            <Typography>{thankYouScreen === false && en.STRIPE_CONTENT}</Typography>
        </>)
    }

    const awaitingStepTitle = () => {
        return (<>
            <Typography variant="h3"> {en.PENDING_APPROVAL} </Typography>
        </>)
    }

    const getDefaultSteps = () => {
        return (<>
            {thankYouScreen === false && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 8 }}>
                    <Typography variant="h3" sx={{ mb: 8 }}></Typography>
                    <FormGroup sx={{ mt: 2 }}>
                        <Button variant="contained" sx={{ mb: 4 }} onClick={() => { gotoStripe() }} >{en.ON_BOARD_TO_STRIPE}</Button>
                    </FormGroup>
                </Box>
            )}
            {thankYouScreen && (
                <>
                    <FormGroup sx={{ mt: 8, mb: 2 }}>
                        {en.THANK_YOU_MENTOR}
                    </FormGroup>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                        <Button variant="contained" sx={{ mb: 4 }} onClick={() => { mentorApproval() }} >{en.SUBMIT_FOR_APPROVAL}</Button>
                    </Box>
                </>
            )}
        </>)
    }

    const getAwaitingStep = () => {
        return (
            <>
                <FormGroup sx={{ mt: 8, mb: 2 }}>
                    <Typography variant="h4"> {en.AWAITING_MENTOR_APPROVAL}</Typography>
                </FormGroup>
            </>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <Box>
                <Box variant="form">
                    {userInfo?.onboarding_status === "PENDING" ? awaitingStepTitle() : defaultStepTitle()}
                    <OptionsWrapper>
                        {userInfo?.onboarding_status === "PENDING" ? getAwaitingStep() : getDefaultSteps()}
                    </OptionsWrapper>
                </Box>
            </Box>
        </ThemeProvider>
    );
}

export default PaymentInfo;
